import PropTypes from 'prop-types';
import React from 'react';

var ChartGrid = function ChartGrid(_ref) {
  var xTicks = _ref.xTicks,
      yTicks = _ref.yTicks,
      xScale = _ref.xScale,
      yScale = _ref.yScale,
      xOffset = _ref.xOffset,
      width = _ref.width,
      height = _ref.height;
  return React.createElement("g", {
    className: "ChartGrid"
  }, yTicks.map(function (tick) {
    return React.createElement("line", {
      key: "grid-y-line-".concat(tick),
      className: "ChartGrid-y-line",
      x1: xOffset,
      x2: width + xOffset,
      y1: yScale(tick),
      y2: yScale(tick)
    });
  }), xTicks.map(function (tick) {
    return React.createElement("line", {
      key: "grid-x-line-".concat(tick),
      className: "ChartGrid-x-line",
      x1: xScale(tick) + xOffset,
      x2: xScale(tick) + xOffset,
      y2: height
    });
  }));
};

ChartGrid.displayName = 'Grid';
ChartGrid.propTypes = {
  xTicks: PropTypes.array.isRequired,
  yTicks: PropTypes.array.isRequired,
  xScale: PropTypes.func.isRequired,
  yScale: PropTypes.func.isRequired,
  xOffset: PropTypes.number,
  width: PropTypes.number,
  height: PropTypes.number
};
ChartGrid.defaultProps = {
  xOffset: 0
};
export default ChartGrid;